import React from 'react';
import PropTypes from 'prop-types';

const WelcomeVideo = ({ src, poster }) => (
  <video className="welcome-video-modal" src={src} autoPlay preload="auto" controls poster={poster}>
    <track kind="captions" />
  </video>
);

WelcomeVideo.propTypes = {
  src: PropTypes.string,
  poster: PropTypes.string,
};

WelcomeVideo.defaultProps = {
  src: null,
  poster: '',
};

export default WelcomeVideo;
